
<template>
  <div class="index">
    <Nav></Nav>
    <!-- 头部 -->
    <div id="h">
      <Heade></Heade>
      <!-- banner -->
      <Banner></Banner>
      <Content></Content>
      <!-- <Sidebar></Sidebar> -->
      <Fotter></Fotter>
    </div>
  </div>
</template>

<script>
import Nav from '../components/index/nav'
import Heade from '../components/index/head'
import Banner from '../components/index/banner'
import Content from '../components/index/content'
import Sidebar from '../components/index/Sidebar'
import Fotter from '../components/index/fotter'

export default {
  components: {
    Nav,
    Heade,
    Banner,
    Content,
    Sidebar,
    Fotter
  },
  mounted() {
    let endtime = window.localStorage.getItem('u')
    if (endtime) {
      if (Math.round(new Date() / 1000) > endtime.expiretime) {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('u')
      }
    }
    if (window.location.hash.includes('index')) {
      window.addEventListener('scroll', function(e) {
        if (window.pageYOffset >= 730) {
          $('#search')
            .stop()
            .slideDown(500)
        } else {
          $('#search')
            .stop()
            .slideUp()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#h {
  height: 140px;
  background: #fff;
  padding-top: 30px;
}
</style>
